import { useContext, useEffect } from 'react';
import { LayoutContext } from '../contexts/LayoutContext';
import ReviewSessionDetail from '../components/Review/ReviewSessionDetail';

function ReviewSessionPage() {
  const { setIsContentScrollable } = useContext(LayoutContext);

  useEffect(() => {
    setIsContentScrollable(false);
    return () => { setIsContentScrollable(true); };
  }, [setIsContentScrollable]);

  return <ReviewSessionDetail />;
}

export default ReviewSessionPage;
